import React from 'react';
import SupportEditEventOption from './SupportEditEventOption';

const SupportEditEventGroup = ({ group, eventTypes, onChange, onAddOption, onAddVariant, onDeleteOption }) => {

    const handleFieldChange = (field, value) => {
        onChange({ ...group, [field]: value });
    };

    const handleUpdateOption = (index, updatedOption) => {
        const newOptions = [...group.options];
        newOptions[index] = updatedOption;
        onChange({ ...group, options: newOptions });
    };

    return (
        <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            {/* Event Header */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 border-b pb-4">
                <div>
                    <label className="block text-xs font-bold text-gray-700 uppercase">Event Name</label>
                    <input
                        type="text"
                        value={group.event_name}
                        onChange={(e) => handleFieldChange('event_name', e.target.value)}
                        className="w-full border p-2 rounded"
                    />
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-700 uppercase">Type</label>
                    <input
                        list="eventTypeOptions"
                        type="text"
                        value={group.event_type}
                        onChange={(e) => handleFieldChange('event_type', e.target.value)}
                        className="w-full border p-2 rounded"
                        placeholder="Select or type..."
                    />
                </div>
            </div>

            {/* Options */}
            <div className="space-y-4">
                {group.options.map((opt, optIdx) => (
                    <SupportEditEventOption
                        key={optIdx}
                        option={opt}
                        onChange={(updatedOption) => handleUpdateOption(optIdx, updatedOption)}
                        onDelete={() => onDeleteOption(optIdx)}
                        onClone={() => onAddVariant(optIdx)}
                    />
                ))}
            </div>

            <div className="mt-3 text-right">
                <button onClick={onAddOption} className="text-xs bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-1 rounded">
                    + Add Option Variation
                </button>
            </div>
        </div>
    );
};

export default SupportEditEventGroup;
